import classnames from 'classnames';
import { omit } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { mediumUp, largeUp } from 'constants/mediaQueries';
import Theme from 'styles/theme';

class PageSectionSecondaryNavigationItem extends React.PureComponent {
  render() {
    const remainingProps = omit(this.props, ['className', 'children', 'forwardedRef', 'item']);
    const classes = classnames(
      'PageSectionSecondaryNavigationItem',
      {
        'PageSectionSecondaryNavigationItem--light': this.props.item.appearance === 'Light',
        'PageSectionSecondaryNavigationItem--dark': this.props.item.appearance === 'Dark',
        'PageSectionSecondaryNavigationItem--neutral': this.props.item.appearance === 'Neutral',
        'PageSectionSecondaryNavigationItem--padding-none': this.props.item.padding === 'None',
        'PageSectionSecondaryNavigationItem--padding-regular':
          this.props.item.padding === 'Regular',
      },
      this.props.className
    );

    return (
      <div className={classes} ref={this.props.forwardedRef} {...remainingProps}>
        {this.props.children}
        <style jsx>
          {`
            .PageSectionSecondaryNavigationItem--light {
              background-color: ${Theme.get('colors-white')};
            }

            .PageSectionSecondaryNavigationItem--dark {
              background-color: ${Theme.get('colors-black')};
            }

            .PageSectionSecondaryNavigationItem--neutral {
              background-color: ${Theme.get('colors-grey')};
            }

            .PageSectionSecondaryNavigationItem--padding-regular {
              padding: ${Theme.get('spacing') * 12}px 0;
            }

            @media ${mediumUp} {
              .PageSectionSecondaryNavigationItem--padding-regular {
                padding: ${Theme.get('spacing') * 13}px 0;
              }
            }

            @media ${largeUp} {
              .PageSectionSecondaryNavigationItem--padding-regular {
                padding: ${Theme.get('spacing') * 20}px 0;
              }
            }
          `}
        </style>
        <style jsx global>
          {`
            .PageSectionSecondaryNavigationItem
              > .PageSectionImageCopy
              .PageSectionImageCopy__content {
              justify-content: flex-end;
            }

            .PageSectionSecondaryNavigationItem--dark > .PageSectionImageCopy * {
              color: ${Theme.get('colors-white')};
            }

            .PageSectionSecondaryNavigationItem > .CardCarousel > .HomepageV2Carousel,
            .PageSectionSecondaryNavigationItem
              > .PageSectionAssetDecoratedCarousel
              > .CardCarousel
              > .HomepageV2Carousel {
              padding-bottom: ${Theme.get('spacing') * 4}px;
            }

            .PageSectionSecondaryNavigationItem
              > .CardCarousel
              > .HomepageV2Carousel
              .HomepageV2Carousel__left-arrow,
            .PageSectionSecondaryNavigationItem
              > .CardCarousel
              > .HomepageV2Carousel
              .HomepageV2Carousel__right-arrow,
            .PageSectionSecondaryNavigationItem
              > .PageSectionAssetDecoratedCarousel
              > .CardCarousel
              > .HomepageV2Carousel
              .HomepageV2Carousel__right-arrow,
            .PageSectionSecondaryNavigationItem
              > .PageSectionAssetDecoratedCarousel
              > .CardCarousel
              > .HomepageV2Carousel
              .HomepageV2Carousel__left-arrow {
              top: calc(50% - ${Theme.get('spacing') * 4}px);
            }
          `}
        </style>
      </div>
    );
  }
}

PageSectionSecondaryNavigationItem.propTypes = {
  className: PropTypes.string,
  item: PropTypes.shape({
    appearance: PropTypes.string.isRequired,
    internalName: PropTypes.string.isRequired,
    navigationTabText: PropTypes.string,
    padding: PropTypes.string.isRequired,
    content: PropTypes.shape({}),
  }).isRequired,
  forwardedRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.elementType }),
  ]),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

PageSectionSecondaryNavigationItem.defaultProps = {
  className: '',
  forwardedRef: null,
};

export default React.forwardRef((props, ref) => {
  return <PageSectionSecondaryNavigationItem {...props} forwardedRef={ref} />;
});
